import React from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import ScrollToTopBtn from "../common/ScrollToTop";

class PrizeReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reports: [],
      years: [],
      member: "tff",
      year: new Date().getFullYear() - 1,
      checkboxValue: {
        delivered: true,
        undelivered: true,
      },
      page: 0,
      rowsPerPage: 100,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      this.getPrizeReports();
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getPrizeReports = async () => {
    try {
      this.setState({ reports: [] });

      const { member, year, checkboxValue } = this.state;

      const response = await reportApi.getPrizeReports(
        member,
        year,
        checkboxValue.delivered,
        checkboxValue.undelivered
      );

      if (response.success) {
        this.setState({ reports: response.data || [] });
      } else {
        this.setState({ reports: [] });
      }
    } catch (error) {
      this.setState({ reports: [] });
    }
  };



  getYears = () => {
    let lastYear = new Date().getFullYear() - 1;
    let years = [lastYear];

    for (let i = 1; i < 10; i++) {
      lastYear = lastYear - 1;
      years.push(lastYear);
    }
    this.setState({ years });
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handleChange = async (e) => {
    const name = e.target.name;
    this.setState({ [name]: e.target.value }, () => {
      this.getPrizeReports();
    });
  };

  handleRadioButton = async (e) => {
    const name = e.target.name;
    const checkboxValue = { ...this.state.checkboxValue };
    checkboxValue[name] = !checkboxValue[name];

    this.setState({ checkboxValue }, () => {
      this.getPrizeReports();
    });
  };

  handledownload = async () => {
    const { member, year } = this.state;
    const excelfile = await reportApi.getExcelFilePrizeReport(
      member,
      year,
      true,
      true,
      true
    );
    if (excelfile === false) {
      toast.error("Ingen data");
    }
  };

  compareBydesc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  };

  compareByasc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return 1;
      if (a[key] > b[key]) return -1;
      return 0;
    };
  };

  sortBy = (key) => {
    let arrayCopy = [...this.state.reports];
    if (this.state.sortDirection === "asc") {
      arrayCopy.sort(this.compareByasc(key));
      this.setState({ reports: arrayCopy, sortDirection: "desc" });
    } else {
      arrayCopy.sort(this.compareBydesc(key));
      this.setState({ reports: arrayCopy, sortDirection: "asc" });
    }
  };

  render() {
    const columns = [
      { id: "companyName", label: "Medlem", minWidth: 50 },
      {
        id: "thisYear",
        label: "Inneværende Premie",
        align: "right",
        minWidth: 250,
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "lastYear",
        label: "Forrige Premie",
        align: "right",
        minWidth: 250,
        format: (value) => value.toLocaleString("de-DE"),
      },
      {
        id: "delivered",
        label: "Levert",
        minWidth: 250,
      },
    ];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={{ width: "100%", paddingTop: 80 }}>
            <Paper style={{ width: "100%", padding: "20px" }}>
              <h3>Status for innberetning av premie</h3>
              <Grid container spacing={3}>
                <Grid item lg={3}>
                  <FormControl fullWidth>
                    <InputLabel>Organisasjon</InputLabel>
                    <Select
                      name="member"
                      value={this.state.member || ""}
                      variant="standard"
                      onChange={this.handleChange}
                    >
                      <MenuItem value="tff">TFF</MenuItem>
                      <MenuItem value="yff">YFF</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={3}>
                  <FormControl fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select
                      name="year"
                      value={this.state.year || ""}
                      variant="standard"
                      onChange={this.handleChange}
                    >
                      {this.state.years.map((year, index) => (
                        <MenuItem key={index} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={6}>
                  <FormGroup
                    row
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <FormLabel component="legend" sx={{ marginRight: 1 }}>
                      Vis:
                    </FormLabel>
                    <FormControlLabel
                      name="delivered"
                      checked={this.state.checkboxValue.delivered}
                      control={<Checkbox color="primary" />}
                      onChange={this.handleRadioButton}
                      label="Leverte"
                    />
                    <FormControlLabel
                      name="undelivered"
                      checked={this.state.checkboxValue.undelivered}
                      onChange={this.handleRadioButton}
                      control={<Checkbox color="primary" />}
                      label="Uleverte"
                    />
                  </FormGroup>
                </Grid>
              </Grid>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        style={{ cursor: "pointer", minWidth: column.minWidth }}
                        onClick={() => this.sortBy(column.id)}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.reports.length > 0 ? (
                    this.state.reports
                      .slice(
                        this.state.page * this.state.rowsPerPage,
                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                      )
                      .map((report, index) => (
                        <TableRow key={index}>
                          {columns.map((column) => {
                            const value = report[column.id];

                            return (
                              <TableCell key={column.id} align={column.align}>
                                {value !== undefined && value !== null
                                  ? column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value.toString()
                                  : "—"}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={columns.length} align="center">
                        Ingen treff
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[10, 50, 100]}
                component="div"
                count={this.state.reports.length}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onPageChange={this.handleChangePage}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<CloudDownloadIcon />}
                onClick={this.handledownload}
              >
                Vis i Excel
              </Button>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default PrizeReport;
